import { Box } from "@mui/material";
import { styled } from "@mui/material/styles";

const CenteredContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  flex: 1,
  minHeight: 0,
  width: "100%",
  padding: theme.spacing(1),
  [theme.breakpoints.up("sm")]: {
    padding: theme.spacing(1),
  },
  [theme.breakpoints.up("md")]: {
    padding: theme.spacing(4),
  },
  [theme.breakpoints.up("lg")]: {
    padding: theme.spacing(5),
  },
}));

const ContentBox = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  flex: 1,
  minHeight: 0,
  width: "100%",
  maxWidth: theme.breakpoints.values.lg,
  backgroundColor: theme.palette.background.paper,
  borderRadius: theme.shape.borderRadius,
  padding: theme.spacing(0),
  [theme.breakpoints.up("sm")]: {
    padding: theme.spacing(1),
  },
  [theme.breakpoints.up("md")]: {
    padding: theme.spacing(5),
  },
}));

function ResponsiveLayout({ children }) {
  return (
    <CenteredContainer>
      <ContentBox>{children}</ContentBox>
    </CenteredContainer>
  );
}
export default ResponsiveLayout;
